import React from "react";
import styled from "@emotion/styled";
import PropTypes from "prop-types";

//Styles Rules
import { Typography } from "../../styles";

const DateTimeDisplay = ({ time, type }) => {
	return (
		<Column>
			<Time>{time}</Time>
			<Type>{type}</Type>
		</Column>
	);
};

DateTimeDisplay.propTypes = {
	time: PropTypes.any,
	type: PropTypes.any,
};

export default DateTimeDisplay;

const Column = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
`;

const Time = styled.p`
	font-weight: ${Typography.fontWeight.black};
	font-size: 2.5rem;
	line-height: 2.4rem;
	letter-spacing: -0.0095em;
`;

const Type = styled.span`
	font-size: 1.6rem;
	line-height: 2.7rem;
	letter-spacing: -0.004em;
	text-transform: none;
`;
